const REDACTED = '[dato omitido]';
const MAX_MESSAGE_LENGTH = 500;

// Screenshots leave the device: never include raw payloads, URLs, credentials or a stack dump.
export const sanitizeErrorText = (text: string): string => text
  .replace(/\n\s*at\s[\s\S]*/g, '')
  .replace(/[\[{][\s\S]*/g, '[contenido omitido]')
  .replace(/\b[a-z][a-z\d+.-]*:\/\/[^\s<>"')]+/gi, '[URL omitida]')
  .replace(/\b(?:Bearer|Basic)\s+[^\s,;]+/gi, REDACTED)
  .replace(/\beyJ[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\b/g, REDACTED)
  .replace(/\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/gi, REDACTED)
  .replace(/\b\d{1,2}\.?\d{3}\.?\d{3}-?[\dkK]\b/g, REDACTED)
  .replace(/\b(?:authorization|(?:[\w-]*token)|(?:[\w-]*secret)|(?:x-)?api[-_]?key|password|cookie|set-cookie|email|rut|phone|tel[eé]fono|nombre|name|first[-_]?name|last[-_]?name|user(?:name|id|info)?|profile|body|payload|data)["']?\s*[:=][\s\S]*/gi, REDACTED)
  .replace(/\b[A-Za-z0-9_+/=-]{32,}\b/g, REDACTED)
  .replace(/[\u0000-\u001f\u007f]/g, ' ')
  .slice(0, MAX_MESSAGE_LENGTH);

export interface ErrorDiagnostic {
  message: string;
  status?: number;
  code?: string;
}

export const getErrorDiagnostic = (error: unknown): ErrorDiagnostic => {
  const fallback = { message: 'No hay detalle técnico disponible.' };
  try {
    if (!error) return fallback;
    if (typeof error === 'string') return { message: sanitizeErrorText(error) || fallback.message };
    if (typeof error !== 'object') return fallback;
    const value = error as { name?: unknown; message?: unknown; code?: unknown; response?: { status?: unknown } };
    const name = typeof value.name === 'string' ? sanitizeErrorText(value.name).slice(0, 60) : 'Error';
    const message = typeof value.message === 'string' ? sanitizeErrorText(value.message) : '';
    const status = value.response?.status;
    // Only conventional transport codes, not arbitrary server strings or business payloads.
    const code = typeof value.code === 'string' && /^(?:ERR_[A-Z_]+|ECONNABORTED|ECONNRESET|ETIMEDOUT)$/.test(value.code) ? value.code : undefined;
    return {
      message: message ? `${name}: ${message}` : fallback.message,
      status: typeof status === 'number' && Number.isInteger(status) && status >= 400 && status <= 599 ? status : undefined,
      code,
    };
  } catch {
    // Even unusual thrown objects/getters must not break the fallback itself.
    return fallback;
  }
};
